import { Component, HostListener } from '@angular/core';
import { MenuItem } from './menu-item.model';
import { AuthService } from '../auth.service';
import { AdminPanelService } from '../../admin-panel/admin-panel.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent {
  isMobile = window.innerWidth <= 896;
  menuItems: MenuItem[] = [
    {
      label: 'Apteki',
      routerLink: '/vehicles',
    },
    {
      label: 'Raporty',
      routerLink: '/reports',
    },
    {
      label: 'Alarmy',
      routerLink: '/services/alarms/alarms-list',
    },
    // {
    //   label: 'Usługi',
    //   routerLink: '/services/reminders/reminders-list'
    // },
    {
      label: 'Mapa',
      routerLink: '/map',
    },
  ];

  get login(): string {
    return this.authService.login;
  }

  get isAdminSidenavOpen(): boolean {
    return this.adminPanelService.isAdminSidenavOpen;
  }

  constructor(
    private authService: AuthService,
    private adminPanelService: AdminPanelService
  ) {}

  logout(): void {
    this.authService.logout();
  }

  openAdminPanel(): void {
    this.adminPanelService.toggleAdminPanelVisibilityNextValue(true);
  }

  closeAdminPanel(): void {
    this.adminPanelService.toggleAdminPanelVisibilityNextValue(false);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this.isMobile = window.innerWidth <= 896;
    });
  }
}
